var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"horizontal-logo"},[_c('b-img',{attrs:{"src":require('../../assets/img/logotipo_sem_texto_small.png'),"fluid":"","alt":"barbosa peixe logotipo"}}),_c('span',{staticClass:"logoTitle"},[_vm._v("BARBOSA PEIXE")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }